import ConfigTabTemplate from './ConfigTabTemplate';
import { useFeature } from '@growthbook/growthbook-react';
import { Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectOption } from '../../@types';
import { CasinoConfigFormData, casinoConfigSchema } from '../../schema';
import FormFieldStack from '../atoms/FormFieldStack';
import Switch from '../atoms/Switch';
import FormSelect from '../molecules/FormSelect';

const DEFAULT_VALUES: CasinoConfigFormData = {
  layoutTemplate: 'CLASSIC',
  jackpotEnabled: false,
};

const resolveCasinoConfigInitialValues = (data?: Partial<CasinoConfigFormData>): CasinoConfigFormData => ({
  ...DEFAULT_VALUES,
  ...data,
  jackpotEnabled: data?.jackpotEnabled ?? DEFAULT_VALUES.jackpotEnabled,
});

const CasinoConfigFields = () => {
  const { value: layoutOptions } = useFeature<SelectOption[]>('casino-layout-templates');
  const {
    control,
    formState: { errors },
  } = useFormContext<CasinoConfigFormData>();

  return (
    <Stack direction='column' spacing={2}>
      <FormSelect
        label='Layout Template'
        name='layoutTemplate'
        control={control}
        error={errors.layoutTemplate}
        options={layoutOptions ?? []}
        required
      />
      <FormFieldStack label='Casino Jackpot'>
        <Controller name='jackpotEnabled' control={control} render={({ field }) => <Switch {...field} ref={null} />} />
      </FormFieldStack>
    </Stack>
  );
};

const CasinoConfigTab = () => {
  return (
    <ConfigTabTemplate<CasinoConfigFormData>
      dataKey='casinoConfig'
      schema={casinoConfigSchema}
      defaultValues={DEFAULT_VALUES}
      resolveInitialValues={resolveCasinoConfigInitialValues}
    >
      <CasinoConfigFields />
    </ConfigTabTemplate>
  );
};

export default CasinoConfigTab;
